export const LineChar = class {
  constructor(labels, dataset) {
    this.dataset = dataset;
    this.labels = labels;
  }

  get options() {
    return {
      legend: {
        display: true,
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontSize: '11',
              fontColor: '#969da5',
            },
            gridLines: {
              color: 'rgba(0,0,0,0.05)',
              zeroLineColor: 'rgba(0,0,0,0.05)',
            },
          },
        ],
        yAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true,
              //max: 65,
            },
          },
        ],
      },
    };
  }

  get styles() {
    return {
      graphContainer: {
        border: '1px solid black',
        padding: '15px',
      },
    };
  }

  get data() {
    const data = [];
    this.dataset.map(item => {
      const record = {
        label: item.year,
        fill: false,
        lineTension: 0.3,
        backgroundColor: item.color,
        borderColor: item.color,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#fff',
        pointBackgroundColor: '#141E41',
        pointBorderWidth: 3,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: '#FC2055',
        pointHoverBorderColor: '#fff',
        pointHoverBorderWidth: 3,
        pointRadius: 5,
        pointHitRadius: 10,
        data: item.months,
        spanGaps: false,
      };
      data.push(record);
    });

    return {
      labels: this.labels,
      datasets: data
    };
  }
};
